export const responseBlobStorages = {
  data: {
    attributes: {
      path: '/ebs/ftpd/test-1640068794020-000001'
    },
    id: 958
  }
};